import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEs = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_FOOTER_TEXT_SHORTER: 'Privacidad de datos y los términos de uso.',
  LABEL_HANA_WIDGET_BANNER_CATEGORIES_TITLE: 'También puedes consultar estos temas frecuentes:',
  LABEL_HANA_WIDGET_VIEW_HISTORY_BUTTON: 'Ver historial',
  MAIN_CHAT_LABEL_PLACEHOLDER_TEXTAREA: 'Escribe la consulta que deseas realizar',
  LABEL_CATEGORIES: 'Categorías',
  LABEL_FILTER_TITLE: 'Elige una opción para obtener sugerencias de consultas relacionada',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Error al cargar los datos',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'No se pudieron cargar los datos',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Reintentar'
});
export default localeEs;